import React, { useContext, useState } from "react";
import ReactStars from "react-rating-stars-component";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { MdList } from "react-icons/md";
import toast, { Toaster } from 'react-hot-toast';

import {FirebaseContext} from '../services/Firebase/Context';

const Feedbacks = ({ id, fullOpacity }) => {
  const { db } = useContext(FirebaseContext);
  const [quality, setQuality] = useState(3);
  const [price, setPrice] = useState(3);
  const [quickness, setQuickness] = useState(3);
  const [global, setGlobal] = useState(3);
  const [comment, setComment] = useState("");
  const [recommend, setRecommend ] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault()

    const decoded = Buffer.from(id, 'base64').toString('ascii');
    const ids = decoded.split("..");
    if (!ids[0] || !ids[1]) {
      toast.error("Impossible d'envoyer un feedback");
      return;
    }
    const feedback = {
      date: Timestamp.fromDate(new Date()),
      quickness:quickness,
      price,
      quality,
      global,
      recomandation: recommend,
      comments: comment,
      organisationId: ids[0],
      recordId: ids[1]
    }
    addDoc(collection(db, "feedbacks"), feedback).then(() => {
      toast.success('Merci pour votre temps. Votre avis a été pris en compte');
    }).catch((err) => {
      toast.error('Erreur veuillez reessayer');
    });
  }

  return (
    <form className="shadow-md" onSubmit={handleSubmit}>
    <div className={`p-4 bg-gray-100 border-t-2 border-blue-400 rounded-t-lg ${fullOpacity ? 'bg-opacity-100' : 'bg-opacity-5'}`}>
      <div className="max-w-sm mx-auto md:w-full md:mx-0">
        <div className="inline-flex items-center space-x-4">
          <MdList className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
            <h1 className="text-gray-600">
              Votre avis nous interesse
            </h1>
        </div>
      </div>

    </div>
    
    <div className="bg-white text-gray-500 flex-col flex items-center w-full py-5 px-5">
      <h1>Qualité</h1>
      <div className="content-center ">
        <ReactStars
          count={5}
          size={24}
          value={quality}
          activeColor="#ffd700"
          onChange={(value) => {
            setQuality(value)
          }}
        />
      </div>
      

      <h1>Rapidité</h1>
      <ReactStars
        count={5}
        size={24}
        value={quickness}
        onChange={(value) => {
          setQuickness(value)
        }}
      />

      <h1>Attractivité Prix</h1>
      <ReactStars
        count={5}
        size={24}
        value={price}
        onChange={(value) => {
          setPrice(value)
        }}
      />

     <h1>Note globale</h1>
      <ReactStars
        count={5}
        size={24}
        value={global}
        onChange={(value) => {
          setGlobal(value)
        }}
      />
     
      <div className="block">
        <h1>Recommanderiez vous</h1>
        <input type="radio" className="form-radio" name="radio" value="1" checked={recommend ===true} onChange={(e)=>{setRecommend (true)}} />
        <span className="ml-2 px-5">Oui</span>
        <input type="radio" className="form-radio" name="radio" value="2" checked={recommend ===false} onChange={(e) => {setRecommend (false) } }/>
        <span className="ml-2 px-5">Non</span>
      </div>

      <h1>Commentaire général</h1>
      <label className="text-gray-700" htmlFor="name">
        <textarea onChange={(e) => {setComment(e.target.value)}} className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Enter your comment" rows="5" cols="40">
        </textarea>
      </label>

      <button type="submit" className="py-2 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-40 transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg">
          Donner mon avis
      </button>
    </div>
    <Toaster />
  </form>
  );
}

export default Feedbacks
